import { React, useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './NoticeCreateBox.css';

import QuillCustomToolbar from './QuillCustomToolbar';
import TitleInput from '../../../Component/NoticeComponent/TitleInput';

const NoticeCreateBox = forwardRef((props, ref) => {

  const [value, setValue] = useState('');

  const TitleRef = useRef();

  const modules = {
    toolbar: {
      container: "#toolbar",
    }
  };

  const formats = [
    "size",
    "underline",
    "italic",
    "bold",
    "align",
    "color",
    "background",
    "image"
  ];

  useImperativeHandle(ref, () => ({
    getTitle: () => {
      return TitleRef.current.getValue();
    },
    getValue: () => {
      return value;
    }
  }))

  function handleChange(value) {
    setValue(value);
  }

  return (
    <TopLevelWrapper>
      <ViewWrapper>
        <ComponentWrapper>
          <Title>제목</Title>
          <TitleInput ref={TitleRef} placeholder="50자 이내의 제목을 입력해주세요"/>
        </ComponentWrapper>
        <ComponentWrapper style={{marginTop: `24px`}}>
          <Title>내용</Title>
          <QuillWrapper className="text-editor">
            <QuillCustomToolbar />
            <ReactQuill
              modules={modules}
              formats={formats}
              theme='snow'
              placeholder='내용을 입력해주세요'
              style={{
                width: `964px`,
                minHeight: `287px`,
                resize: 'none',
                border: `1px solid #DFDFDF !Important`,
                borderRadius: `30px`,
                fontFamily: 'NotoSansKR-Regular',
                fontSize: '14px',
                color: '#232323'
              }}
              value={value}
              onChange={handleChange} />
          </QuillWrapper>
        </ComponentWrapper>
      </ViewWrapper>
    </TopLevelWrapper>
  )
})

export default NoticeCreateBox;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 1020px;
  // height: 535px;

  margin-top: 38px;
  margin-bottom: 96px;
  padding-bottom: 68px;

  border-radius: 30px;
  box-shadow: 0px 40px 50px rgba(240, 232, 227, 0.5);
  background-color: #FFFFFF;
`;

const ViewWrapper = styled.div`
  diplay: flex;
  flex-direction: column;

  justify-content: flex-start
  align-items: flex-start;
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;
`;

const Title = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 0 0 0;

  color: #232323;
`;

const QuillWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 16px;

  // border: none !Important;
  // width: 964px;
  // height: 320px;
`;